import React, { Component } from 'react'

export default class SubMenu extends Component {
  render() {
    return (
      <div className="sub-menu">
        {this.props.children}
      </div>
    )
  }
}